<template>
  <ODialog ref="dialog" :maxWidth="700">
    <OLoading :value="row == null" />

    <v-card v-if="row != null">
      <v-toolbar class="card-bar">
        <v-toolbar-title>Token</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$refs.dialog.$dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-3">
        <div class="h-row-wrap children-pa-3">
          <div class="cap-cont oderon-col-12">
            <label>Código</label>
            <p>{{ row.code }}</p>
          </div>

          <div class="cap-cont oderon-col-6">
            <label>Subject</label>
            <p>{{ row.subject }}</p>
          </div>

          <div class="cap-cont oderon-col-6">
            <label>App</label>
            <p>{{ row.app }}</p>
          </div>

          <div class="cap-cont oderon-col-6">
            <label>Criado em</label>
            <p>{{ row.createdAt | brLongDateTime }}</p>
          </div>
          <div class="cap-cont oderon-col-6">
            <label>Expira em</label>
            <p>{{ row.expiresAt | brLongDateTime }}</p>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pa-6">
        <v-spacer />
        <OHoldToConfirm color="error" @confirmed="emitDelete">
          Apagar...
        </OHoldToConfirm>
      </v-card-actions>
    </v-card>
  </ODialog>
</template>

<script>
import { Token } from '@/models'

export default {
  mixins: [require('oderon-vue/cpts/dialog-promise-mixin').default],
  components: {
    OLoading: require('oderon-vue/cpts/OLoading').default,
    ODialog: require('oderon-vue/cpts/ODialog').default,
    OHoldToConfirm: require('oderon-vue/cpts/OHoldToConfirm').default
  },
  data() {
    return this.reset()
  },
  methods: {
    reset() {
      return {
        code: null,
        row: null
      }
    },

    async open(code) {
      Object.assign(this, this.reset())
      this.code = code
      this.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      this.row = await Token.findById(this.code)
    },

    emitDelete() {
      this.$refs.dialog.$apply('DELETE')
    }
  }
}
</script>

<style>
.scroll-x {
  overflow-x: auto;
  white-space: pre-wrap;
}
</style>
